import reactContainerFactory from '@/components/react-container/reactContainerFactory';
import { lazy } from 'react';

const whWcs = {
  path: '/wh-wcs',
  name: 'whwcs',
  meta: {
    title: 'WH WCS',
    icon: 'WH WCS',
  },
  redirect: '/wh-wcs/agv-move-task',
  component: (): Promise<any> => import('@/views/layout/index.vue'),
  children: [
    {
      path: 'agv-move-task',
      name: 'whwcs.agvmovetask',
      meta: {
        title: 'AGV Move Task',
      },
      component: reactContainerFactory({
        name: 'whwcs.agvmovetask',
      }),
      props: {
        component: (): any =>
          lazy(() => import('@/react-app/pages/wh-wcs/agv-move-task')),
      },
    },
  ],
};

export default whWcs;
